import { useNavigate, useParams } from 'react-router-dom'

import { ReconciliationFromFinancialDocumentSidePanelDocument } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { getReconcilableJournalLine } from 'modules/finance/components/Invoices/Detail/Content/Form/_utils'
import { ReconciliationForm } from 'modules/finance/components/ReconciliationForm'
import { ReconciliationNotFound } from 'modules/finance/components/ReconciliationSidepanel/ReconciliationNotFound'

export const ReconciliationFromFinancialDocumentSidePanel = () => {
  const { invoiceId: financialDocumentId } = useParams()

  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { data, loading } = useQuery(ReconciliationFromFinancialDocumentSidePanelDocument, {
    variables: { financialDocumentId: Number(financialDocumentId) },
  })
  const { reconciliationsSeeJournalEntriesPage } = data?.banking?._policies || {
    reconciliationsSeeJournalEntriesPage: { can: false },
  }
  const currency = data?.finance.financialDocument?.currency ?? ''

  if (!financialDocumentId || !data) return null

  const onCloseSidePanel = () => {
    navigate(
      navigation.finance.invoices.list.invoiceId.fullPath({ invoiceId: financialDocumentId })
    )
  }

  const financialDocument = data?.finance.financialDocument
  const journalLines = data?.finance.journalLinesConnection.nodes ?? []

  if (!financialDocument) return null

  const journalLine = getReconcilableJournalLine(financialDocument, journalLines)

  if (!reconciliationsSeeJournalEntriesPage.can) {
    return <ReconciliationNotFound onClose={onCloseSidePanel} />
  }

  return (
    <Sidepanel
      title={i18n.t('finance.reconciliations.sidepanel_title')}
      width="extended"
      open
      onClose={onCloseSidePanel}
    >
      <ReconciliationForm
        sourceType="financialDocument"
        journalLine={journalLine}
        loading={loading}
        currency={currency}
        onJournalLineFullyReconciled={() => {}}
        allowedJournalEntryTypes={['bank']}
        onlyJournalLinesFromSuspenseLedgerAccount
        reconcilableJournalLineTitle={i18n.t(
          'finance.reconciliations.match_with_bank_accounts_journal_lines'
        )}
        summaryTitle={i18n.t(
          'finance.reconciliations.summary_empty_state_from_financial_document.title'
        )}
        summarySubtitle={i18n.t(
          'finance.reconciliations.summary_empty_state_from_financial_document.description'
        )}
      />
    </Sidepanel>
  )
}
